import "./App.css";
import logo from "./assets/MyCircle_Full-Logo_Screen_Full-Colour-RGB-1.png";
import bubbles from "./assets/Group-1.png";

function App() {
  return (
    <div className="page">
      <header className="hero">
        <div className="hero-content">
          <img src={logo} alt="MyCircle Community for you" className="logo" />
          <p className="tagline">
            A safe place during life&apos;s ups and downs.
            <br />
            Your go-to app for advice, support,
            <br />
            and local community meets...
          </p>
        </div>
      </header>

      <footer className="footer">
        Coming soon to the App Store &amp; Google Play
      </footer>
    </div>
  );
}

export default App;
